<template>
  <div class="adv-overview-wrapper">
    <div class="overview-wrapper">
      <div class="overview">
        <div class="left">
          <div class="content-box d-flex flex-column">
            <div>
              <span>
                好消息！我們現已為品牌開通社群帳戶 (<span style="color:#164269;">ID:{{ user.communityId }}</span>)
                ，歡迎閣下使用公司電郵登入U Lifestyle App《社群》：
                <span style="color:#164269;">{{ user.communityEmail }}</span>
                分享品牌故事及最新內容，盡情展示獨家促銷活動，期待看到您的分享！
              </span>
              <span>
                U Lifestyle《社群》是一個生活、旅遊及美食交流專區，雲集「旅遊」、「美食」、「生活」及「寵物」等多個人氣主題，
                為大眾建構一個貼地交流及紀錄生活的網絡，輕鬆分享最Hit話題！

                成為《社群》認證商戶，您可以：
                <ul>
                  <li>將品牌最新活動及資訊分享予數十萬名用戶，大大增加品牌曝光率</li>
                  <li>透過帖文加強品牌互動，與消費者建立更緊密連結</li>
                  <li>連繫品牌社交平台帳戶及網頁</li>
                  <li>更全面地展示品牌資料、最新帖文、優惠及相關U Lifestyle文章</li>
                </ul>

                只要持續於《社群》發佈高質帖文，將有機會獲得更多曝光：
                <ul>
                  <li>U Lifestyle《社群》藍剔認證</li>
                  <li>U Lifestyle社交平台認證轉載</li>
                  <li>推薦帖文置於U Lifestyle《社群》首頁及相關社交平台</li>
                  <li>更多等您來發掘！</li>
                </ul>
              </span>
            </div>
            <div class="central-box">
              <div class="blue-border d-flex justify-content-center ">
                <div class="border-wrapper">
                  <div class="central-content">
                    <div>立即掃瞄進入</div>
                    <div>U Lifestyle App</div>
                    <div>《社群》</div>
                  </div>
                </div>
                <div class="border-wrapper">
                  <div style="width:100%; height:100%">
                    <div class="triangle"></div>
                    <div class="white-box">
                      <div class="icon-qr"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="img-box">
            <div class="central-img">
            <span><img
              src="../../assets/img/notification/noti-phone-large.png"
            /></span>
            </div>
          </div>

        </div>
      </div>
      <div class="vl" v-if="isPremium"></div>
      <div class="overview" v-if="isPremium"></div>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters(['role']),
    ...mapState(['user']),
  },
};
</script>

<style scoped lang="scss">

.adv-overview-wrapper {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #dde1e5;
  padding-top: 20px;
  width: 100%;
  display:inline-block;
  color: #fff;
  position: relative;

  @include respond(tab-landscape) {
    height: auto;
  }

  .overview-wrapper{
    width: 100%;
    justify-content: space-between;

    .overview{
      width: 100%;
      color: #000;
      display: flex;
      justify-content: space-between;
      padding: 13px 13px;
      box-sizing: border-box;

      .left {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-content: space-between;
        .title {
          color: #696969;
          font-size: 14px;

          @include respond(tab-landscape) {
            font-size: 12px;
          }
        }
        .content-box {
          width: 66%;
          @include respond(tab-landscape) {
            width: 100%;
          }
        }
        .img-box {
          width: 33%;
          @include respond(tab-landscape) {
            width: 100%;
          }
        }
        .central-box {
          @include respond(tab-landscape) {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          }
        }
        .central-img {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        }
        .central-content {
          max-width: 170px;
          width: 90%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

      }
      .blue-border {
        max-width: 393px;
        min-width: 303px;
        min-height:179px;
        font-size: 18px;
        text-align: center;
        color: #fff;
        background: #318ce1;
        border-radius: 8px;
        border: 1px solid #dde1e5;
        padding: 12px 25.5px 12px 25.2px;
        @include respond(tab-landscape) {
          flex-wrap: wrap;
          max-width: 109px;
          max-height:none;
          font-size: 14px;
          padding: 9.3px 19.7px 9.3px 0;
        }
        .border-wrapper {
          width: 50%;
          text-align: center;
          position: relative;

          .white-box {
            left: 15%;
            position: absolute;
            height: 155px;
            width: 155px;
            border-radius: 8px;
            background: #fff;
            z-index: 10;
            @include respond(tab-landscape) {
              top: 12%;
              width: 119.5px;
              height: 119.5px;
            }
          }
          .triangle {
            top: 45%;
            left: 0%;
            position: absolute;
            width: 0px;
            height: 0px;
            border-style: solid;
            border-width: 0 20px 20px 20px;
            border-color: transparent transparent #FFF transparent;
            transform: rotate(270deg);
          }
          .icon-qr {
            width: 90%;
            height: 90%;
            background-size: contain;
            background-image: url(../../assets/img/notification/noti-qr-large.png);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

</style>
